import {
  Supplier,
  SupplierCreate,
  SupplierFilters,
  SupplierOption,
  SupplierUpdate,
} from "@/types/inventory/supplier";
import { Page } from "@/types/pagination";

import { requestData } from "@/api/api-config";
import { supplierFiltersToSearchParams } from "@/api/provider/inventory/filter-search-params";

export async function fetchSuppliers(
  params?: SupplierFilters,
): Promise<Page<Supplier> | null> {
  return await requestData<Page<Supplier>>(`inventory/suppliers/list`, "get", {
    searchParams: supplierFiltersToSearchParams(params),
  });
}

/** Supplier id/name choices, readable by Inventory Analytics roles without View Inventory. */
export async function fetchSupplierOptions(): Promise<SupplierOption[]> {
  return (
    (await requestData<SupplierOption[]>(
      "inventory/suppliers/options",
      "get",
    )) ?? []
  );
}

export async function fetchSupplier(
  supplierId: string,
): Promise<Supplier | null> {
  return await requestData<Supplier>(
    `inventory/suppliers/${supplierId}`,
    "get",
  );
}

export async function deleteSupplier(
  supplierId: string,
): Promise<boolean | null> {
  return await requestData<boolean>(
    `inventory/suppliers/archive/${supplierId}`,
    "delete",
  );
}

export async function addSupplier(
  formData: SupplierCreate,
): Promise<Supplier | null> {
  const suppliers = await requestData<Supplier[]>(
    "inventory/suppliers/create",
    "post",
    { json: [formData] },
    false,
  );
  return suppliers?.[0] ?? null;
}

export async function updateSupplier(
  supplierId: string,
  formData: SupplierUpdate,
): Promise<Supplier | null> {
  const options =
    formData instanceof FormData ? { body: formData } : { json: formData };
  return await requestData<Supplier>(
    `inventory/suppliers/update/${supplierId}`,
    "put",
    options,
  );
}
